export default {
  INSTALL: 'install',
  CHARGE: 'charge',
  TRAIN: 'train',
  UPGRADE: 'upgrade',
  REPAIR: 'repair'
}
